var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS2Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 87 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3358 0.434249C38.3369 2.29547 41.8599 15.7614 41.6094 25.3025H31.1043C31.2626 21.0769 30.6669 13.8523 24.5959 11.1457C17.5278 7.99456 13.3446 11.7047 11.004 13.8795L2.60521 8.023C2.68922 7.93224 2.78193 7.83001 2.88316 7.71837C2.98918 7.60146 3.10307 7.47325 3.2255 7.33543C5.50425 4.77009 10.7435 -1.1281 23.3358 0.434249ZM7.08838 34.5254L40.9793 57.778C41.6171 50.4203 37.3569 42.7256 31.2484 38.4962L0.685417 17.1744L0.399173 20.4765C-0.0805117 26.0102 2.47347 31.3741 7.08838 34.5254ZM63.8504 15.2969C48.8493 17.1581 45.3264 30.624 45.5768 40.1652H56.0819C55.9236 35.9395 56.5193 28.7149 62.5903 26.0083C69.6584 22.8572 73.8416 26.5673 76.1822 28.7422L84.581 22.8856C84.497 22.7949 84.4043 22.6926 84.303 22.581C84.197 22.4641 84.0831 22.3359 83.9607 22.1981C81.6819 19.6327 76.4427 13.7345 63.8504 15.2969ZM80.0978 49.388L46.207 72.6406C45.5692 65.2829 49.8293 57.5882 55.9378 53.3588L86.5008 32.037L86.787 35.3391C87.2667 40.8728 84.7127 46.2367 80.0978 49.388Z",
    fill: "url(#s2_logo_paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "s2_logo_paint0_linear",
    x1: 43.5931,
    y1: 0.174805,
    x2: 43.5931,
    y2: 72.6406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2Logo);
export default __webpack_public_path__ + "static/media/s2-logo.5eba3554.svg";
export { ForwardRef as ReactComponent };